import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheckDouble = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "#2E2D37",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon/Check 4",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1202 18.0222C11.9048 18.0222 11.6895 17.9398 11.5255 17.7758L10.0453 16.312L11.1787 15.0504L12.1202 15.9918L19.9644 8.14754C20.2933 7.81866 20.8257 7.81866 21.1537 8.14754C21.4826 8.47557 21.4826 9.008 21.1537 9.33687L12.7148 17.7758C12.5508 17.9398 12.3355 18.0222 12.1202 18.0222ZM6.98312 17.7758C7.14714 17.9398 7.36246 18.0222 7.57779 18.0222C7.79311 18.0222 8.00844 17.9398 8.17246 17.7758L16.6114 9.33687C16.9402 9.008 16.9402 8.47557 16.6114 8.14754C16.2833 7.81866 15.7509 7.81866 15.422 8.14754L7.57779 15.9918L4.83575 13.2497C4.50772 12.9217 3.97529 12.9217 3.64642 13.2497C3.31838 13.5786 3.31838 14.111 3.64642 14.4391L6.98312 17.7758Z"
		})
	})
});
export default SvgIconCheckDouble;
